import { prepareSpendSummaryData } from '@/dashboards/SpendSummary/helpers/prepareSpendSummaryData';
import { useSpendSummaryQuery } from '@/dashboards/SpendSummary/hooks/useSpendSummaryQuery';
import { FormattedSpendSummaryData } from '@/dashboards/SpendSummary/types';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { useMemo } from 'react';

export const useSpendSummaryData = (): FormattedSpendSummaryData => {
    const {
        colorMap: { categoryColorMap, variableColorMap },
        dashboard: { dashboardVariables },
    } = useDashboardGlobalContext();

    const { queryResult } = useSpendSummaryQuery();
    const { data } = queryResult;

    return useMemo(
        () =>
            prepareSpendSummaryData({
                rows: data?.rows,
                dashboardVariables,
                categoryColorMap,
                variableColorMap,
            }),
        [categoryColorMap, data?.rows, dashboardVariables, variableColorMap],
    );
};
